const WEIGHT: Record<string, number> = {
  composition: 5,
  aggregation: 4,
  association: 2,
  dependence: 1,
};
const PRIORITY = ['composition', 'aggregation', 'association', 'dependence'];

export const computeDominantLinkType = (
  edges: { data: { id?: string; link?: { name?: string } } }[],
) => {
  const scoreByType: Record<string, number> = {};
  const countByType: Record<string, number> = {};
  for (const edge of edges) {
    const type = edge.data.link?.name;
    if (typeof type !== 'string') continue;
    countByType[type] = (countByType[type] ?? 0) + 1;
    scoreByType[type] = (scoreByType[type] ?? 0) + (WEIGHT[type] ?? 1);
  }
  const types = Object.keys(scoreByType).sort(
    (a, b) =>
      scoreByType[b] - scoreByType[a] ||
      countByType[b] - countByType[a] ||
      (PRIORITY.indexOf(a) < 0 ? 999 : PRIORITY.indexOf(a)) -
        (PRIORITY.indexOf(b) < 0 ? 999 : PRIORITY.indexOf(b)),
  );
  return { dominantType: types[0], scoreByType, countByType };
};
